import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-download\"><defs><style type=\"text/css\"></style></defs><path d=\"M146.285714 877.714286h731.428572v-146.285715h146.285714v292.571429H0v-292.571429h146.285714v146.285715z m511.634286-509.805715H877.714286l-365.714286 412.306286L146.285714 367.908571h232.886857V0h278.674286v367.908571z\" p-id=\"18010\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol